<template>
  <div class="table">
    <el-table
      :data="overtimes"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      empty-text=""
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        sortable
        prop="name"
        label="EMPLOYEES' NAME"
        width="200"
        fixed="left"
      ></el-table-column>
      <el-table-column
        sortable
        prop="pin"
        label="PIN"
        width="100"
      ></el-table-column>
      <el-table-column
        sortable
        prop="start_date"
        label="START DATE"
        width="180"
      >
        <template slot-scope="scope">
          {{ dateFormatter(scope.row.start_date) }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="end_date"
        label="END DATE"
        width="180"
        :formatter="dateFormatter"
      >
        <template slot-scope="scope">
          {{ dateFormatter(scope.row.start_date) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="actual_overtime"
        label="OVERTIME (MINS)"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="overtime_in_hour"
        label="OVERTIME (HRS)"
        width="180"
      ></el-table-column>
      <el-table-column
        sortable
        prop="status"
        label="STATUS"
        width="120"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'pending'" class="status pending">
            Pending
          </div>
          <div v-if="scope.row.status === 'approved'" class="status approve">
            Approved
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container" v-if="!tableLoading">
      <el-pagination
        mini
        @size-change="handleSizeChangeOvertimes"
        @current-change="handleCurrentChangeOvertimes"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPageOvertimes"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalOvertimes"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "admin/attendance/overtime"
);
import { dateFormatter } from "@/helpers/functions";
export default {
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  computed: {
    ...mapState([
      "overtimes",
      "perPageOvertimes",
      "totalOvertimes",
      "tableLoading",
    ]),
    currentPage: {
      get() {
        return this.$store.state.admin.attendance.overtime.pageOvertimes;
      },
      set(value) {
        this.$store.commit("admin/attendance/overtime/OVERTIME_MUTATIONS", {
          key: "pageOvertimes",
          value,
        });
      },
    },
    filterDate: {
      get() {
        return this.$store.state.admin.attendance.overtime.overtimeDate;
      },
    },
  },
  methods: {
    dateFormatter,
    ...mapActions([
      "handleSizeChangeOvertimes",
      "handleCurrentChangeOvertimes",
      "approveOvertime",
      "rejectOvertime",
    ]),
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
  },
};
</script>
